export const decodeContractorPackageLocalContentTarget = (target) => {
    return {
        contractorPackageId: target.contractor_package_id,
        created: target.created,
        districtTargetValue: target.district_target_value ?? 0,
        id: target.contractor_package_local_content_target_id,
        regionalTargetValue: target.regional_target_value ?? 0,
        targetType: target.target_type,
        targetValue: target.target_value
    };
};
export const encodeContractorPackageLocalContentTarget = (target) => {
    return {
        contractor_package_id: target.contractorPackageId,
        contractor_package_local_content_target_id: target.id,
        created: target.created,
        district_target_value: target.districtTargetValue ?? 0,
        regional_target_value: target.regionalTargetValue ?? 0,
        target_type: target.targetType,
        target_value: target.targetValue
    };
};
